/**
 * @ram/i18n — message catalogues + locale loader.
 *
 * Phase 0 ships EN + AR for the Client Portal (§0/11). The Admin Dashboard
 * uses EN strings only at launch but consumes the same loader so AR can be
 * enabled later without a code change.
 */
import en from "./locales/en.json";
import ar from "./locales/ar.json";

export type Locale = "en" | "ar";

// vue-i18n's `LocaleMessage` type is structural and recursive; using
// `Record<string, any>` here keeps the package free of a vue-i18n peer
// dependency while still letting consumers pass `messages` straight to
// `createI18n({ messages })` without a cast.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const messages: Record<Locale, Record<string, any>> = { en, ar };

export const RTL_LOCALES: Locale[] = ["ar"];

export function applyDocumentLocale(locale: Locale) {
  const html = document.documentElement;
  html.setAttribute("lang", locale);
  html.setAttribute("dir", RTL_LOCALES.includes(locale) ? "rtl" : "ltr");
}

export const LOCALE_STORAGE_KEY = "ram-locale";

export function readStoredLocale(fallback: Locale = "en"): Locale {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  return stored === "en" || stored === "ar" ? stored : fallback;
}

export function persistLocale(locale: Locale) {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
}
